export default __webpack_public_path__ + "static/media/bunnyhead-main.045cae28.svg";